import { useEffect, useState } from 'react';
import { listCategories } from '@/modules/inventory/services';
import { listItems } from '@/modules/inventory/services';
import type { Category } from '@/modules/inventory/types';
import type { InventoryItem } from '@/modules/inventory/types';
import {
  RESERVATION_STATUS_LABELS,
  type ReservationStatus,
} from '@/modules/reservations/types';
import type { CalendarEventFilters } from '@/modules/calendar/types';

type CalendarFiltersProps = {
  filters: CalendarEventFilters;
  onChange: (filters: CalendarEventFilters) => void;
};

const STATUS_OPTIONS: Array<ReservationStatus | 'all'> = [
  'all',
  'draft',
  'confirmed',
  'in_progress',
  'completed',
  'cancelled',
];

export function CalendarFilters({ filters, onChange }: CalendarFiltersProps) {
  const [categories, setCategories] = useState<Category[]>([]);
  const [items, setItems] = useState<InventoryItem[]>([]);

  useEffect(() => {
    void Promise.all([listCategories(), listItems()]).then(([cats, its]) => {
      setCategories(cats.filter((c) => c.active));
      setItems(its.filter((i) => i.mode === 'rental'));
    });
  }, []);

  return (
    <div className="calendar-filters users-form-grid">
      <label className="auth-label auth-label--row">
        <input
          type="checkbox"
          checked={filters.showReservations !== false}
          onChange={(e) =>
            onChange({
              ...filters,
              showReservations: e.target.checked,
            })
          }
        />
        Mostrar reservas
      </label>
      <label className="auth-label auth-label--row">
        <input
          type="checkbox"
          checked={filters.showLogistics !== false}
          onChange={(e) =>
            onChange({
              ...filters,
              showLogistics: e.target.checked,
            })
          }
        />
        Mostrar logística
      </label>
      <label className="auth-label auth-label--row">
        <input
          type="checkbox"
          checked={filters.showMaintenance !== false}
          onChange={(e) =>
            onChange({
              ...filters,
              showMaintenance: e.target.checked,
            })
          }
        />
        Mostrar mantenimiento
      </label>
      <label className="auth-label">
        Estado reservas
        <select
          value={filters.status ?? 'all'}
          onChange={(e) =>
            onChange({
              ...filters,
              status: e.target.value as ReservationStatus | 'all',
            })
          }
        >
          {STATUS_OPTIONS.map((s) => (
            <option key={s} value={s}>
              {s === 'all' ? 'Todos' : RESERVATION_STATUS_LABELS[s]}
            </option>
          ))}
        </select>
      </label>
      <label className="auth-label">
        Artículo
        <select
          value={filters.itemId ?? ''}
          onChange={(e) => {
            const next = { ...filters };
            if (e.target.value) next.itemId = e.target.value;
            else delete next.itemId;
            onChange(next);
          }}
        >
          <option value="">Todos</option>
          {items.map((item) => (
            <option key={item.id} value={item.id}>
              {item.sku} — {item.name}
            </option>
          ))}
        </select>
      </label>
      <label className="auth-label">
        Categoría
        <select
          value={filters.categoryId ?? ''}
          onChange={(e) => {
            const next = { ...filters };
            if (e.target.value) next.categoryId = e.target.value;
            else delete next.categoryId;
            onChange(next);
          }}
        >
          <option value="">Todas</option>
          {categories.map((cat) => (
            <option key={cat.id} value={cat.id}>
              {cat.name}
            </option>
          ))}
        </select>
      </label>
    </div>
  );
}
